"use client";

import { useEffect } from "react";
import { isStaleApp, reloadForNewVersion } from "@/lib/stale-app";

/** Loads the page again when it turns out to be running an older version of Davnai (after an update went live). */
export default function StaleAppGuard() {
  useEffect(() => {
    const onError = (e: ErrorEvent) => {
      if (isStaleApp(e.error ?? e.message)) reloadForNewVersion();
    };
    const onRejection = (e: PromiseRejectionEvent) => {
      if (isStaleApp(e.reason)) reloadForNewVersion();
    };
    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);
  return null;
}
